var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('my-order-on-table',{attrs:{"cart":_vm.cart,"requestingCart":_vm.requestingCart},on:{"getCart":_vm.getCart,"callWaiter":function($event){return _vm.$emit('callWaiter')}}}),(_vm.error.show)?_c('error-dialog',{attrs:{"data":_vm.error},on:{"DismissErrorDialog":function($event){return _vm.DismissErrorDialog()}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }